import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { notCompareColumn, setNonDispalyValue } from "../../commonComponents/EventHandler"
import CustomLink from "../../commonComponents/CustomLink"
import { isLoggedIn } from "../../../api/AuthService"

const Attributes = (props) => {
   const navigate = useNavigate()
   
   const [data, setData] = useState();

   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)

   useEffect(() => {
      if (props.data) {
         setData(props.data);
      }
   }, [props.data]);

   function compare(data, keys) {
      let data1 = null;
      let data2 = null;
   
      for (let index = 0; index < keys.length; index++) {
         if (!notCompareColumn(keys[index])) {
            if (data1 === null) {
               data1 = data[keys[index]];
            } else {
               data2 = data[keys[index]];
            }
         }
      }
   
      if (data1 === undefined || data2 === undefined) {
         return false;
      }
   
      if (typeof data1 === "object" && typeof data2 === "object") {
         return JSON.stringify(data1) !== JSON.stringify(data2);
      }
   
      return data1 !== data2;
   }

   useEffect(() => {
      if (!isLoggedIn()) {
         navigate("/")
      }
   }, [navigate])

   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name);
         }, 1000); // Add a 1-second delay
   
         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay);
      }
   }, [changeOccure, props.name, props.handleDiffCategory]);

   const getRowsData = () => {
      // var isCategoryDiffer = false
      var items = data
      var keys = getKeys()
      return items.map((row, index) => {
         const compareValue = compare(row, keys)
         if (compareValue && changeOccure == false) {
            setChangeOccure(true)
            props.handleDiffCategory(props.name)
         }
         return (
            <tr
               key={index}
               className={compareValue ? "compareStyle col-md-4" : "col-md-4"}
            >
               <RenderRow key={index} data={row} keys={keys} />
            </tr>
         )
      })
   }

   const getKeys = function () {
      return Object.keys(data[0])
   }

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const getPCLinks = function (data, link, id) {
      var elements = data.map((value, index) => {
         var num = index + 1
         if (
            link[index] &&
            link[index].trim() !== "" &&
            id[index] &&
            id[index].trim() !== "" &&
            id[index].toLowerCase().trim() !== "no access"
         ) {
            return (
               <span key={index}>
                  <CustomLink
                     id={id[index].trim()}
                     link={link[index].trim()}
                     name={value}
                  />
                  {num === data.length ? "" : "|"}
               </span>
            )
         } else {
            return (
               <span key={index}>
                  {value}
                  {num === data.length ? "" : "|"}
               </span>
            )
         }
      })
      return elements
   }

   const RenderColumn = function (props) {
      return props.keys.map((key, index) => {
         // if (props.data[key] !== "" && props.data[key] != null) {
         if (props.data[key] != null) {
            if (setNonDispalyValue(key)) {
               return null
            } else if (
               key.toLowerCase().trim() === "p" &&
               props.data["id"] &&
               props.data["id"].toLowerCase().trim() !== "no access"
            ) {
               let name = props.data[key]

               return (
                  <div key={index} style={{ minWidth: "9rem" }}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                     <span>
                        {props.data["link"] ? (
                           <CustomLink
                              id={props.data["id"]}
                              link={props.data["link"]}
                              name={name}
                           />
                        ) : (
                           <span>{name}</span>
                        )}
                     </span>
                  </div>
               )
            } else if (key.toLowerCase() === "name") {
               let nameData = props.data[key] ? props.data[key].split("|") : []
               let nameLink = props.data["methodLink"]
                  ? props.data["methodLink"].split("|")
                  : []
               let nameId = props.data["methodId"]
                  ? props.data["methodId"].split("|")
                  : []
               let getnamelinks = getPCLinks(nameData, nameLink, nameId)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     {getnamelinks}
                  </div>
               )
            } else if (
               typeof props.data[key] == "object" &&
               key &&
               key.toLowerCase() === "cps"
            ) {
               let names = props.data[key]["name"]
                  ? props.data[key]["name"].split("|")
                  : []
               let links = props.data[key]["link"]
                  ? props.data[key]["link"].split("|")
                  : []
               let ids = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
               let getLinks = getPCLinks(names, links, ids)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     {getLinks}
                  </div>
               )
            } else if (
               key.toLowerCase() === "ref" ||
               key.toLowerCase().includes("tmrdn")
            ) {
               var refData = props.data[key] ? props.data[key].split("|") : []
               var refLink = props.data["refLink"] ? props.data["refLink"].split("|") : []
               var refId = props.data["refId"] ? props.data["refId"].split("|") : []
               var getlinks = getPCLinks(refData, refLink, refId)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     {getlinks}
                  </div>
               )
            } else if (props.data[key] != null && key.toLowerCase() === "cmn") {
               var name = props.data[key]["name"]
                  ? props.data[key]["name"].split("|")
                  : []
               var link = props.data[key]["link"]
                  ? props.data[key]["link"].split("|")
                  : []
               var id = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
               var getlinks = getPCLinks(name, link, id)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     {getlinks}
                  </div>
               )
            }

            if (props.data[key].length > 0) {
                  return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                     <span className="lineBreak">{props.data[key]}</span>
                  </div>
               )
            }
         } else return null
      })
   }

   const RenderRow = (props) => {
      var colKeys = []
      return props.keys.map((key, index) => {
         if (props.data[key] != null && typeof props.data[key] == "object") {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn isbold={true} data={props.data[key]} keys={colKeys} />
               </td>
            )
         } else if (setNonDispalyValue(key)) {
            return null
         } else {
            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   return (
      <div className="performanceTableFixHead">
         {data && data.length > 0 && (
            <table id="tab-separtor">
               <thead>
                  <tr>
                     <th className="col-md-4"></th>
                     <th className="col-md-4">{partName}{" "}{props.revision["releaseRevision"]}</th>
                     <th className="col-md-4">{partName}{" "}{props.revision["obsoleteRevision"]}</th>
                  </tr>
               </thead>
               <tbody>{getRowsData()}</tbody>
            </table>
         )}
      </div>
   )
}

export default Attributes
